/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetUserLanguageRequest } from '../../models/set-user-language-request';

export interface LocalizationUserUserIdLanguagePost$Params {
  userId: string;
      body?: SetUserLanguageRequest
}

export function localizationUserUserIdLanguagePost(http: HttpClient, rootUrl: string, params: LocalizationUserUserIdLanguagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, localizationUserUserIdLanguagePost.PATH, 'post');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

localizationUserUserIdLanguagePost.PATH = '/localization/user/{userId}/language';
